import { ReducersTypes } from "constants/ReducersTypes";
import moment from "moment";
import { getUXSettingsFromStorage } from "utils";

const savedFilters = getUXSettingsFromStorage("ANALYTICS_FILES_FILTERS");

export const initialFilesReportFilters = {
  page: 1,
  per_page: 20,
  sort_by: "uploaded_at",
  sort_order: "desc",
  interval: "",
  from_date: moment().format("MM/DD/YYYY"),
  to_date: moment().format("MM/DD/YYYY"),
  file_type: "",
  status: "",
};

const initialState = {
  isFetching: false,
  isExporting: false,
  list: [],
  exportedData: [],
  total: 0,
  pagination: {
    nextPage: 0,
    prevPage: 0,
    totalPages: 0,
  },
  filters: {
    ...initialFilesReportFilters,
    ...savedFilters,
  },
};

const filesReportList = (state = initialState, action) => {
  switch (action.type) {
    case ReducersTypes.SET_FILES_REPORT_LIST_DATA:
      return {
        ...state,
        ...action.payload,
      };

    case ReducersTypes.SET_FILES_REPORT_LIST_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload,
        },
      };

    case ReducersTypes.RESET_FILES_REPORT_LIST_FILTERS:
      return {
        ...state,
        filters: {
          ...initialFilesReportFilters,
          ...action.payload,
        },
      };

    default:
      return state;
  }
};

export default filesReportList;
